import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

/*
  Fascia informativa sui cookie.

  Ciesse non usa cookie di profilazione né strumenti di terze parti che
  tracciano la navigazione: solo archiviazione tecnica (sessione, cache
  offline, token delle notifiche). Per i soli cookie tecnici il consenso non
  serve, serve l'informativa: quindi una fascia che si legge e si chiude, non
  un muro con accetta/rifiuta che chiederebbe un permesso di cui non c'è
  bisogno. Se un domani si aggiunge uno strumento di analisi statistica,
  questa fascia va trasformata in una richiesta di consenso vera.
*/

// Cambiando versione la fascia ricompare a tutti: serve quando l'informativa
// cambia davvero, non a ogni deploy.
const CHIAVE_LETTA = 'ciesse.cookie-notice.v1';

// Pagine pubbliche: qui la fascia ha senso. Nell'area riservata l'utente ha un
// account, l'archiviazione è quella tecnica del servizio e una barra fissa in
// basso coprirebbe i pulsanti delle pagine di lavoro.
const PAGINE_PUBBLICHE = [
  '/',
  '/contatti',
  '/supporto',
  '/login',
  '/privacyPolicy',
  '/terms',
  '/recupero-password',
];

export default function CookieNotice() {
  const { pathname } = useLocation();

  const [visibile, setVisibile] = useState(false);

  useEffect(() => {
    try {
      setVisibile(localStorage.getItem(CHIAVE_LETTA) !== 'letta');
    } catch {
      // Storage negato (navigazione privata): meglio mostrarla in più che in meno.
      setVisibile(true);
    }
  }, []);

  const chiudi = () => {
    try {
      localStorage.setItem(CHIAVE_LETTA, 'letta');
    } catch {
      // Se non si può ricordare, tornerà al prossimo accesso: nessun danno.
    }

    setVisibile(false);
  };

  const paginaPubblica =
    PAGINE_PUBBLICHE.includes(pathname) || pathname.startsWith('/reset-password/');

  if (!visibile || !paginaPubblica) return null;

  return (
    <div
      role="region"
      aria-label="Informativa sui cookie"
      className="fixed inset-x-0 bottom-0 z-[100] px-4 pb-4"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-4 rounded-3xl border border-white/10 bg-slate-950/95 p-5 text-sm text-slate-300 shadow-[0_0_50px_rgba(0,0,0,0.45)] backdrop-blur-xl sm:flex-row sm:items-center sm:justify-between">
        <p className="leading-6">
          Questo sito usa solo cookie e archiviazione tecnica necessari a far
          funzionare le pagine e l'area riservata. Nessun cookie di
          profilazione, nessun tracciamento di terze parti.{' '}
          <Link
            to="/privacyPolicy"
            className="font-semibold text-cyan-300 underline-offset-4 transition hover:underline"
          >
            Informativa privacy e cookie
          </Link>
        </p>

        <button
          type="button"
          onClick={chiudi}
          className="shrink-0 rounded-xl bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-blue-600/25 transition hover:bg-blue-700"
        >
          Ho capito
        </button>
      </div>
    </div>
  );
}
